import React from "react";
import MicrosoftIcon from "../../../images/microsoft-icon.png";

import { microsoftAuth } from '../../../services/api/auth'

const MicrosoftAuthentication = () => {

    const handleMicrosoftAuth = async () => {
        const response = await microsoftAuth()
        window.location = response.data
    }


    return(
        <div className="flex hover:surface-200 flex-row justify-content-center goole-microsoft-btns font-normal p-2" onClick={handleMicrosoftAuth}>
            <img src={MicrosoftIcon} alt="Microsoft icon not found" width="15px" height="15px" className="mr-3"/>
            <a className=" border-round "> Login With Microsoft</a>
        </div>
    )
}

export default MicrosoftAuthentication